import React from 'react';
import '../grammar-page.css';
import { FaBookOpen, FaLightbulb } from 'react-icons/fa';

const GerundsInfinitivesExplanation = () => {
  return (
    <div className="grammar-explanation">
      <h2><FaBookOpen /> Gerunds and Infinitives</h2>
      <p>
        A <strong>gerund</strong> is a verb form ending in <em>-ing</em> that functions as a noun.
        An <strong>infinitive</strong> is <em>to</em> + verb. Certain verbs are followed by one or the other,
        and with some verbs the meaning changes completely depending on which you choose.
      </p>

      <div className="grammar-explanation-grid">
        <div className="example-block">
          <h3><FaLightbulb /> Verbs + gerund</h3>
          <ul>
            <li>enjoy, finish, suggest, avoid, consider, mind, keep, miss</li>
            <li>After prepositions: <em>I'm interested in learning more.</em></li>
            <li>As a subject: <em>Learning a language takes time.</em></li>
          </ul>
        </div>

        <div className="example-block">
          <h3><FaLightbulb /> Verbs + infinitive</h3>
          <ul>
            <li>want, hope, decide, plan, promise, refuse, seem, agree, learn, offer</li>
            <li>To express purpose: <em>We need time to rest.</em></li>
            <li>After adjectives: <em>It's important to be patient.</em></li>
          </ul>
        </div>
      </div>

      <h3><FaLightbulb /> Verbs where the meaning changes</h3>
      <div className="grammar-flex-table">
        {[
          ['Verb', '+ Gerund (-ing)', '+ Infinitive (to…)'],
          ['Remember', 'I remember locking the door. (a memory of the past)', 'Remember to lock the door. (a duty)'],
          ['Forget', "I'll never forget seeing Paris. (a memory)", 'I forgot to buy milk. (a missed duty)'],
          ['Stop', 'Stop talking. (end the action)', 'Stop to rest. (pause in order to rest)'],
          ['Try', 'Try adding more salt. (experiment)', 'Try to be quiet. (make an effort)'],
        ].map(([verb, gerund, infinitive], index) => (
          <div key={index} className={`grammar-flex-row${index === 0 ? ' header' : ''}`}>
            <div className="grammar-cell">{verb}</div>
            <div className="grammar-cell">{gerund}</div>
            <div className="grammar-cell">{infinitive}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GerundsInfinitivesExplanation;
